import { Routes } from '@angular/router';
import { EstatisticasComponent } from './components/estatisticas/estatisticas.component';
import { PagamentosComponent } from './components/pagamentos/pagamentos.component';
import { UtilizadoresComponent } from './components/utilizadores/utilizadores.component';
import { CampanhasComponent } from './components/campanhas/campanhas.component';
import { ConfiguracoesComponent } from './components/configuracoes/configuracoes.component';
import { AdminExtendDetalheCampanhaComponent } from './components/campanhas/components/admin-extend-detalhe-campanha/admin-extend-detalhe-campanha.component';
import { LogsComponent } from './components/logs/logs.component';

export const Adminroutes: Routes = [
  {
    path: 'estatisticas',
    component: EstatisticasComponent,
  },
  {
    path: 'pagamentos',
    component: PagamentosComponent,
  },
  {
    path: 'utilizadores',
    component: UtilizadoresComponent,
  },
  {
    path: 'campanhas',
    component: CampanhasComponent,
  },
  {
    path: 'configuracoes',
    component: ConfiguracoesComponent,
  },
  {
    path: 'registos',
    component: LogsComponent,
  },
  {
    path: 'campanha-detalhe/:id',
    component: AdminExtendDetalheCampanhaComponent,
  },
  {
    path: 'campanha-detalhe/:nome/:id',
    component: AdminExtendDetalheCampanhaComponent,
  },
];
